
/**
 * State for the list Offers
 *
 * @export
 * @class State
 */
export class State {
	listOffers: any;
	current_step: number;
	flexPremiumPricer: boolean;
}

export const initialState: State = {
	listOffers: null,
	current_step: null,
	flexPremiumPricer: false
};
